import { httpInstance } from '../httpInstance';

/**
 * Servicio para obtener todas las configuraciones de producto
 * @returns Promise con la lista de configuraciones
 */
export const getProductServiceConfigsService = () => {
  return httpInstance.get('/product-service/configs');
};

/**
 * Servicio para obtener una configuración específica por ID y producto
 * @param configId - ID de la configuración (ej: 'PRICING', 'BASE')
 * @param productId - ID del producto (ej: 'PAYMENT_LINKS')
 * @returns Promise con la configuración solicitada
 */
export const getProductServiceConfigByIdService = (configId: string, productId: string) => {
  return httpInstance.get(`/product-service/config/${configId}`, {
    params: { product_id: productId }
  });
};

/**
 * Servicio para crear o actualizar una configuración de producto
 * @param data - Datos de la configuración a crear/actualizar
 * @returns Promise con la configuración creada/actualizada
 */
export const createOrUpdateProductServiceConfigService = (data: any) => {
  return httpInstance.post(`/product-service/config`, data);
};

/**
 * Servicio para actualizar una configuración de producto (alias)
 * @param data - Datos de la configuración a actualizar
 * @returns Promise con la configuración actualizada
 */
export const updateProductServiceConfigService = (data: any) => {
  return createOrUpdateProductServiceConfigService(data);
};

/**
 * Servicio para eliminar una configuración de producto
 * @param configId - ID de la configuración (ej: 'PRICING')
 * @param productId - ID del producto (ej: 'PAYMENT_LINKS')
 * @returns Promise con el resultado de la eliminación
 */
export const deleteProductServiceConfigService = (configId: string, productId: string) => {
  // Usar axios.request para tener control total sobre la configuración
  console.log('[deleteProductServiceConfigService] Deleting:', { configId, productId });
  
  return httpInstance.request({
    method: 'DELETE',
    url: `/product-service/config/${configId}`,
    params: {
      productId: productId
    },
    // Asegurar que no se envíe body
    data: null,
  });
};
